(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileSecurityStack', ["path", "$q", function (path, $q) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/common/security-stack').template('security-stack'),
            scope: { showAttachments: '=' },
            link: function ($scope, element, attrs) {
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    return $q.when();
                };
                $scope.panel = {
                    'type': 'multi-widget',
                    'logic': {
                        'name': 'scanDetailsLogic',
                        'updateTick': 60000
                    },
                    'uuid': '96d4b3f1-f171-45a3-8437-dd349c1159d3',
                    'size': 'medium',
                    'class': 'light',
                    'wrapper': {
                        'type': 'widget-panel',
                        'title': 'Security Stack',
                        'class': 'avanan white-body overflow-auto'
                    }
                };
                if ($scope.showAttachments) {
                    $scope.panel.logic.attachmentsStatusWidget = {
                        'type': 'data-table',
                        'logic': {
                            'name': 'securityStackAttachmentsStatusLogic',
                            'updateTick': null
                        },
                        'size': 'display-none',
                        'class': 'file-security-stack-table vertical-middle',
                        'wrapper': {
                            'type': 'widget-panel',
                            'title': 'Insecure attachments found',
                            'class': 'file-security-stack-category'
                        },
                        'columns': [
                            {
                                'id': 'entity_id',
                                'hidden': true,
                                'primary': true
                            },
                            {
                                'id': 'ContentType',
                                'text': false,
                                'converter': 'mimeIconConverter',
                                'converterArgs': { 'niceMimeColumn': 'nice_mime_type' },
                                'dataStyle': { 'width': '40px' },
                                'style': { 'width': '40px' }
                            },
                            {
                                'id': 'Name',
                                'text': 'Name',
                                'href': {
                                    'type': 'file',
                                    'params': { 'id': 'entity_id' }
                                },
                                'dataClass': 'file-security-attachment-name'
                            },
                            {
                                'id': 'finding',
                                'converter': 'multiListConverter',
                                'converterArgs': {
                                    'countPostfix': 'activities',
                                    'collapseRest': true,
                                    'expanded': 4,
                                    'uniqueCountText': 'times',
                                    'uniqueTrim': true,
                                    'elementAsTooltip': true,
                                    'class': 'max-width-300'
                                },
                                'dataClass': 'file-security-finding-column'
                            },
                            {
                                'id': 'exceptionLinks',
                                'hidden': true
                            },
                            {
                                'id': 'reportLinks',
                                'hidden': true
                            },
                            {
                                'id': 'scanStatus',
                                'text': ' ',
                                'dataClass': 'file-security-status-icon',
                                'converter': 'attachmentScanStatusConverter'
                            }
                        ]
                    };
                }
                $scope.filters = {
                    uuid: $scope.panel.uuid,
                    forceUpdate: function () {
                        $scope.panel.forceUpdate();
                    }
                };
                $scope.$watch('panel.wrapper.filters', function () {
                    if ($scope.panel.wrapper.filters) {
                        $scope.filters.filters = $scope.panel.wrapper.filters;
                    }
                });
            }
        };
    }]);
}());